import { Injectable } from '@angular/core';

import { IntercityStop, ProductCategory, RidangoReduxAction } from '@ridango/core';

@Injectable()
export class StopsActions {
    static FETCH_START = '[Stops]: Fetch start';
    static FETCH_SUCCESS = '[Stops]: Fetch success';
    static FETCH_FAILED = '[Stops]: Fetch failed';
    static FETCH_END = '[Stops]: Fetch end';

    static FETCH_INTERCITY_START = '[Stops]: Fetch intercity stops start';
    static FETCH_INTERCITY_SUCCESS = '[Stops]: Fetch intercity stops success';
    static FETCH_INTERCITY_FAILED = '[Stops]: Fetch intercity stops failed';
    static FETCH_INTERCITY_END = '[Stops]: Fetch intercity stops end';

    static FETCH_ZONES_START = '[Stops]: Fetch zones start';
    static FETCH_ZONES_SUCCESS = '[Stops]: Fetch zones success';
    static FETCH_ZONES_FAILED = '[Stops]: Fetch zones failed';
    static FETCH_ZONES_END = '[Stops]: Fetch zones end';

    static FETCH_STOPS_WITH_ZONES_START = '[Stops]: Fetch stops with zones start';
    static FETCH_STOPS_WITH_ZONES_SUCCESS = '[Stops]: Fetch stops with zones success';
    static FETCH_STOPS_WITH_ZONES_FAILED = '[Stops]: Fetch stops with zones failed';
    static FETCH_STOPS_WITH_ZONES_END = '[Stops]: Fetch stops with zones end';

    static SET_GROUPS = '[Stops]: Set groups';
    static SET_DEFAULT_GROUP = '[Stops]: Set default group';
    static SET_SELECTED_GROUP = '[Stops]: Set selected group';
    static SET_SELECTED_ORIGIN = '[Stops]: Set selected origin';
    static SET_SELECTED_DESTINATION = '[Stops]: Set selected destination';
    static SET_ALL_AREAS_SELECTED = '[Stops]: Set all areas selected';
    static SET_SELECTED_STOPS = '[Stops]: Set selected stops';

    static CLEAR_ALL_SELECTIONS = '[Stops]: Clear all selections';

    fetchStart(): RidangoReduxAction {
        return {
            type: StopsActions.FETCH_START,
        };
    }

    fetchSuccess(payload: any): RidangoReduxAction {
        return {
            type: StopsActions.FETCH_SUCCESS,
            payload: payload,
        };
    }

    fetchFailed(payload: any): RidangoReduxAction {
        return {
            type: StopsActions.FETCH_FAILED,
            payload: payload,
        };
    }

    fetchEnd(): RidangoReduxAction {
        return {
            type: StopsActions.FETCH_END,
        };
    }

    fetchIntercityStopsStart(): RidangoReduxAction {
        return {
            type: StopsActions.FETCH_INTERCITY_START,
        }
    }

    fetchIntercityStopsSuccess(payload: any): RidangoReduxAction {
        return {
            type: StopsActions.FETCH_INTERCITY_SUCCESS,
            payload: payload,
        };
    }

    fetchIntercityStopsFailed(payload: any): RidangoReduxAction {
        return {
            type: StopsActions.FETCH_INTERCITY_FAILED,
            payload: payload,
        };
    }

    fetchIntercityStopsEnd(): RidangoReduxAction {
        return {
            type: StopsActions.FETCH_INTERCITY_END,
        };
    }

    fetchZonesStart(): RidangoReduxAction {
        return {
            type: StopsActions.FETCH_ZONES_START,
        }
    }

    fetchZonesSuccess(payload: any): RidangoReduxAction {
        return {
            type: StopsActions.FETCH_ZONES_SUCCESS,
            payload: payload,
        };
    }

    fetchZonesFailed(payload: any): RidangoReduxAction {
        return {
            type: StopsActions.FETCH_ZONES_FAILED,
            payload: payload,
        };
    }

    fetchZonesEnd(): RidangoReduxAction {
        return {
            type: StopsActions.FETCH_ZONES_END,
        };
    }

    fetchStopsWithZonesStart(): RidangoReduxAction {
        return {
            type: StopsActions.FETCH_STOPS_WITH_ZONES_START,
        }
    }

    fetchStopsWithZonesSuccess(payload: any): RidangoReduxAction {
        return {
            type: StopsActions.FETCH_STOPS_WITH_ZONES_SUCCESS,
            payload: payload,
        };
    }

    fetchStopsWithZonesFailed(payload: any): RidangoReduxAction {
        return {
            type: StopsActions.FETCH_STOPS_WITH_ZONES_FAILED,
            payload: payload,
        };
    }

    fetchStopsWithZonesEnd(): RidangoReduxAction {
        return {
            type: StopsActions.FETCH_STOPS_WITH_ZONES_END,
        };
    }

    setGroups(groups: ProductCategory[]): RidangoReduxAction<ProductCategory[]> {
        return {
            type: StopsActions.SET_GROUPS,
            payload: groups,
        };
    }

    setDefaultGroup(group: ProductCategory): RidangoReduxAction<ProductCategory> {
        return {
            type: StopsActions.SET_DEFAULT_GROUP,
            payload: group,
        };
    }

    setSelectedGroup(group: ProductCategory): RidangoReduxAction<ProductCategory> {
        return {
            type: StopsActions.SET_SELECTED_GROUP,
            payload: group,
        };
    }

    setSelectedOrigin(stop: IntercityStop) {
        return {
            type: StopsActions.SET_SELECTED_ORIGIN,
            payload: stop,
        };
    }

    setSelectedDestination(stop: IntercityStop) {
        return {
            type: StopsActions.SET_SELECTED_DESTINATION,
            payload: stop,
        };
    }

    setAllAreasSelected(isSet: boolean = false) {
        return {
            type: StopsActions.SET_ALL_AREAS_SELECTED,
            payload: isSet,
        };
    }

    setSelectedStops(stops: any) {
        return {
            type: StopsActions.SET_SELECTED_STOPS,
            payload: stops,
        };
    }

    clearAllSelections() {
        return {
            type: StopsActions.CLEAR_ALL_SELECTIONS,
        };
    }
}
